import React, {useCallback, useState} from 'react';
import {useSelector, useDispatch, shallowEqual} from 'react-redux';
// import {useLocation} from 'react-router-dom';
import classnames from 'classnames';

import utilitiesMapboxAPI from '../../utilities/utilitiesMapboxAPI';
import * as actionCreators from '../../store/actions';
// import useMarketChange from '../Containers/Map/Elements/MapFilters/hooks/useMarketChange';
// import {sitemapLink} from '../Containers/Sitemap';

let errorTimeout = null;
const AutocompleteHeader = () => {
  // const location = useLocation();
  const [value, setValue] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [results, setResults] = useState([]);
  const [hideMobile, setHideMobile] = useState(true);
  const [cursor, setCursor] = useState(0);
  const [showResult, setShowResults] = useState(false);
  const [error, setError] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [type, setType] = useState('Address');
  const {isMobile, mapData, placesSettings} = useSelector(state => ({
    isMobile: state.ui.isMobile,
    mapData: state.map.mapData,
    placesSettings: state.map.placesSettings,
  }), shallowEqual);
  // const isSitemapPage = useMemo(() => location.pathname === sitemapLink, [location]);

  const dispatch = useDispatch();
  const setLoading = useCallback(state => dispatch(actionCreators.setLoading(state)), [dispatch]);
  // const [changeMarket] = useMarketChange();
  // const setNavigationProperty = useCallback(
  //   (state, loadProperty = false) =>
  //     dispatch(actionCreators.setNavigationProperty(state, '', loadProperty)),
  //   [dispatch],
  // );
  // const setMapFormData = useCallback(data => dispatch(actionCreators.setMapFormData(data)), [
  //   dispatch,
  // ]);
  // const resetMapSearchResults = useCallback(
  //   () => dispatch(actionCreators.resetMapSearchResults()),
  //   [dispatch],
  // );

  const handleResultClick = useCallback(
    async (result) => {
      setValue(result.place_name || result.text);
      setShowResults(false);
      setHideMobile(true);
      setError('');
      clearTimeout(errorTimeout);

      setLoading(true);
      await utilitiesMapboxAPI.getGAPIResult(
        result,
        placesSettings,
        (msg) => {
          setError(msg);
          errorTimeout = setTimeout(() => {
            setError('');
          }, 5000);
          setResults([]);
        },
        false, // !isSitemapPage,
      );
      // if (resultItem.folio) {
      //   const formData = {
      //     id_by_address: {
      //       type: 'autocomplete',
      //       paramName: 'id_by_address',
      //       value: {[resultItem.id]: resultItem.title},
      //     },
      //   };
      //   resetMapSearchResults();
      //   setMapFormData({formData});
      //   setNavigationProperty(resultItem, true);
      // }
      // else {
      //   setNavigationProperty('');
      //   if (resultItem?.extent) {
      //     changeMarket(resultItem, false);
      //   }
      // }
      setLoading(false);
    },
    [setLoading, placesSettings],
  );

  const onFocus = useCallback(() => {
    setShowResults(true);
  }, [setShowResults]);

  const onBlur = useCallback(() => {
    setShowResults(false);
  }, [setShowResults]);

  const onChange = useCallback(
    (e) => {
      const val = e.target.value;
      if (val) {
        setShowResults(true);
      }
      setValue(val);
      setCursor(0);
      if (val && val.trim().length > 2) {
        utilitiesMapboxAPI.getResult(
          val,
          (data) => {
            setResults(data);
            if (val && data.length < 1) {
              setError('No matching results found');
              clearTimeout(errorTimeout);
            }
            else {
              setError('');
              clearTimeout(errorTimeout);
            }
          },
          mapData.mapboxToken,
        );
      }
    },
    [setValue, setResults, setCursor, mapData.mapboxToken],
  );

  const onKeyDown = useCallback(
    (e) => {
      if (type === 'APN') {
        return;
      }

      switch (e.keyCode) {
        case 40:
          e.preventDefault();
          if (cursor < results.length - 1) {
            setCursor(cursor + 1);
          }
          break;

        case 38:
          e.preventDefault();
          if (cursor > 0) {
            setCursor(cursor - 1);
          }
          break;

        case 13:
          e.preventDefault();
          e.stopPropagation();
          handleResultClick(results[cursor]);
          break;

        default:
          break;
      }
    },
    [setCursor, type, cursor, results, handleResultClick],
  );

  const mobileToggleButton = useCallback(
    (hide) => {
      if (!isMobile) {
        return '';
      }

      return (
        <button
          type="button"
          className="search-toggle"
          aria-label="Search"
          onMouseDown={() => {
            setHideMobile(hide);
          }}
        >
          {hide ? <i className="icon-b icon-b-arrow-left" /> : <i className="icon-b icon-b-search" />}
        </button>
      );
    },
    [isMobile, setHideMobile],
  );

  return isMobile && hideMobile ? (
    mobileToggleButton(false)
  ) : (
    <div
      id={isMobile ? 'map-search-mobile' : 'map-search'}
      className={`map-search${isMobile ? '-mobile' : ''} ${isMobile && hideMobile ? 'hide' : ''}`}
    >
      <div className="map-search-box">
        <div className="search-box map">
          <form>
            {mobileToggleButton(true)}
            <input
              type="search"
              name="search"
              placeholder="Place or Address"
              autoComplete="off"
              maxLength="256"
              value={value}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={onKeyDown}
              onChange={onChange}
            />
            <button type="button" className="form-submit extra" aria-label="Search">
              <i className="icon-b icon-b-ic-search-grey-big" />
            </button>
            {value && (
              <button
                type="button"
                className="no-style clear"
                onClick={() => {
                  setValue('');
                  setError('');
                  setResults([]);
                  clearTimeout(errorTimeout);
                }}
              >
                <i
                  className={classnames('icon-b', {
                    'icon-b-close': isMobile,
                    'icon-b-times-circle': !isMobile,
                  })}
                />
              </button>
            )}
          </form>
        </div>
        {value && error && (
          <ul>
            <li className="error">{error}</li>
          </ul>
        )}
        {showResult && results && results.length > 0 ? (
          <ul>
            {results.map((item, id) => (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
              <li
                key={`item-${item.id}-${id + 1}`}
                role="option"
                aria-selected={cursor === id}
                className={cursor === id ? 'active' : ''}
                onMouseDown={() => handleResultClick(item)}
              >
                <div className="place-name">{item.place_name || item.text}</div>
                <div className="place-type">{item.place_type.join(', ')}</div>
              </li>
            ))}
          </ul>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default AutocompleteHeader;
